<template>
  <div v-if="loaded">
    <template v-if="routeMatchesComponent()">
      <!-- TODO Improves -->
      <div class="white-bg p3 m3">
        <span class="col-12 block h4n bold">{{ getReferencelabel("COMMUNICATION_PREFERENCE") }}</span>
        <div v-show="showMessage" class="mt2" :class="{ 'success': success, 'danger': !success }">
          <span>{{ statusMessage }}</span>
        </div>
        <form id="updatePreferences" class="my2" @submit.prevent="submitPreferences">
          <div v-for="newsletter in newsletters" :key="newsletter.name" class="my2">
            <div v-if="newsletter.name === 'ucpa_newsletter' || showAdditionalNewsletter" class="flex">
              <div class="col-2 md-col-1 lg-col-1 flex justify-center">
                <label class="switch">
                  <input :id="newsletter.name" v-model="newsletter.value" type="checkbox" class="pointer" @change="newsletter.name === 'ucpa_newsletter' ? toggleUCPANewsletter(newsletter.value) : null">
                  <span class="slider round"></span>
                </label>
              </div>
              <div class="full-hight flex items-center ml2 col-10 md-col-11 lg-col11">
                <label :for="newsletter.name" class=" pointer">{{ newsletter.label }}</label>
              </div>
            </div>
            <div class="col-12 center mt2"><span v-if="newsletter.name === 'ucpa_newsletter' && !showAdditionalNewsletter">{{ getReferencelabel('UNCHECKED_NEWSLETTER') }}</span></div>
          </div>
          <div class="flex justify-center col-12">
            <Button reference="SAVE" class="center mt2 col-12 md-col-6 lg-col-4 submit" btn-color="blue" />
          </div>
        </form>
        <a class="p1 h5n center underline block" href="https://www.ucpa.com/cgi">
          {{ getReferencelabel('PLUS_POLICY') }}
        </a>
      </div>
    </template>
    <router-view v-else />
  </div>
</template>

<script>

import { useRoute } from 'vue-router';
import { useStore } from 'vuex';
import { computed, ref, onBeforeMount, getCurrentInstance } from 'vue';
import Button from '@/components/elements/Button';
import { getReferencelabel, isInImpersonateModeNotification, routeIsCurrentComponent } from '@/mixins/utils';

import { getUser, updateNewsletters } from '@/mixins/requests';

export default {

  components: { Button },
  setup () {
    const route = useRoute();
    const store = useStore();
    const loaded = ref(false);

    const routeMatchesComponent = () => routeIsCurrentComponent(route.name, getCurrentInstance());

    const success = ref(false);

    const newsletters = ref([
      { name: 'ucpa_newsletter', label: getReferencelabel('UCPA_NEWSLETTER') }
    ]);
    const statusMessage = ref('');
    const showMessage = computed(() => !!statusMessage.value);
    const showAdditionalNewsletter = computed(() => newsletters.value[0].value);

    function toggleUCPANewsletter (value) {
      if (!value) {
        newsletters.value.forEach(n => {
          n.value = false;
          return n;
        });
        // sellectAllinput.value = false
      }
    }

    async function submitPreferences () {
      if (isInImpersonateModeNotification()) {
        return;
      }

      // Iniciate the loading screen and reset message boxes
      store.commit('setLoading', true);
      success.value = false;
      statusMessage.value = '';

      // Create and populate object newsletters
      const data = { ...store.state.user };
      data.newsletters = {};
      newsletters.value.forEach(newsletter => {
        data.newsletters[newsletter.name] = newsletter.value;
      });

      // Send request to update the newsletter preferences with the data
      const response = await updateNewsletters(data);
      if (response && response.success) {
        statusMessage.value = 'Préférences de newsletter mises à jour avec succès.';
        success.value = true;
      } else {
        statusMessage.value = 'Échec de la mise à jour des préférences de la newsletter. Réessayez plus tard.';
        success.value = false;
      }

      store.commit('setLoading', false);
    }

    onBeforeMount(async () => {
      store.commit('setLoading', true);
      const user = await getUser();
      if (!user) {
        return null; // Loading and redirect to SSO
      }
      newsletters.value.forEach(newsletter => {
        newsletter.value = !!(store.state.user.newsletters && store.state.user.newsletters[newsletter.name]);
      });

      loaded.value = true;

      store.commit('setLoading', false);
    });

    return { loaded, newsletters, route, submitPreferences, statusMessage, success, showMessage, store, toggleUCPANewsletter, showAdditionalNewsletter, getReferencelabel, routeMatchesComponent };
  }
};
</script>

<style>
.input-height {
  height: 50px;
}

@media (max-width: 40em) {
  .my-profile-text {
    text-align: center;
  }
}

</style>
